import axios from "axios";
import { getAuth } from "firebase/auth";

const API_BASE_URL = "/.netlify/functions";

async function getIdToken() {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) throw new Error("Użytkownik nie jest zalogowany");
  return user.getIdToken(true);
}

export const fetchImage = async ({ category, model, style, language }) => {
  const idToken = await getIdToken();

  const payload = { category, model, language }; // Includes language in payload
  if (model === "essential-v2") {
    payload.style = style;
  }

  try {
    const response = await axios.post(
      `${API_BASE_URL}/fetch-image`,
      payload,
      {
        headers: { Authorization: `Bearer ${idToken}` },
        timeout: 30000,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching image:", error.message, error.response?.data);
    throw new Error(
      error.response?.data?.error ||
      "Wystąpił błąd podczas generowania obrazu (Przeciążenie sieci). Spróbuj ponownie później."
    );
  }
};